<template>
  <div>
    <div class="right-title">
      <span>投诉处理</span>
    </div>
    <div class="content-box">
      <div class="search-box">
        <div class="shaixuan">
          筛选：
          <a href="javascript:void 0" @click="listOrders('')" :class="{'active':listOrder === ''}">默认</a>
          <a href="javascript:void 0" @click="listOrders(1)" :class="{'active':listOrder === 1}">未处理</a>
          <a href="javascript:void 0" @click="listOrders(2)" :class="{'active':listOrder === 2}">处理中</a>
          <a href="javascript:void 0" @click="listOrders(3)" :class="{'active':listOrder === 3}">已处理</a>
        </div>
        <el-input
          class="search"
          type="text"
          prepend="iconbianji1"
          placeholder="请输入编号或标题"
          v-model="search"
        >
        </el-input>
        <el-button @click="keyWord" type="primary" style="margin-left: 10px;">搜索</el-button>
      </div>
      <div class="tab-box">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%;height: 100%"
          :header-cell-style="{background: '#f2f3f5',color: '#000;'}"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            fixed
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            prop="status"
            label=" "
            width="1"
            align="center">
            <template slot-scope="scope">
              <span class="hals-color" style="cursor: pointer"
              ><i class="iconfont icondian"
                  style="color: #e4393c;width: 33px;font-size: 33px;height: 33px;"
                  v-if="scope.row.status===0"></i> </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="id"
            label="编号"
            width="80"
            align="center">
          </el-table-column>
          <el-table-column
            prop="id"
            label="状态"
            width="110"
            align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.state === 1" style="color: #d50000">未处理</span>
              <span v-if="scope.row.state === 2" style="color: #999999">处理中</span>
              <span v-if="scope.row.state === 3" style="color: #5daf34">已处理</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="title"
            label="标题"
            align="center"
          >
            <template slot-scope="scope">
              <span class="hals-color" style="cursor: pointer" @click="toDetail(scope.row.id,scope.row.status)"
              >{{scope.row.title}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="type"
            label="类型"
            align="center"
            show-overflow-tooltip>
            <template>
              <span>投诉</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="addr"
            label="接收时间"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.create_time}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="user_name"
            label="发送人"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="addr"
            label="查看详情"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span @click="toDetail(scope.row.id,scope.row.status)" class="hal-cursor">查看详情</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="id"
            label="状态修改"
            width="110"
            align="center">
            <template slot-scope="scope">
              <el-button @click="setState(3, scope.row.id)" v-if="scope.row.state === 2" type="success">设为已处理</el-button>
              <el-button @click="setState(2, scope.row.id)" v-if="scope.row.state === 3" type="primary" style="background: #d50000;border: 0;">设为处理中</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-box">
          <div>
            <el-button type="danger" @click="deleteList">删除</el-button>
          </div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page.pageNum"
            :page-size="page.pageSize"
            layout="prev, pager, next, jumper"
            :total="page.pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>
    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'
  export default {
    data(){
      return {
        search: '',        // 搜索
        tableData: [],     // 列表数据
        multipleSelection: [], //  选中的候选人
        page: {
          pageNum: 1,
          pageSize: 10,
          pageTotal: 1
        },
        listOrder:''
      }
    },
    computed:{
      user() {
        return this.$store.state.user
      }
    },
    created() {
      this.$emit('setType', 3)
      this.init()
    },
    methods:{
      setState(num,id){
        this.$api.apiContent.changeMessageComplaintsState({
          adminId: this.user.id,
          id:id,
          state: num
        }).then(()=>{
          this.init()
        }).catch(e=>{
          this.$message.error(e.info)
        })
      },
      listOrders(num){
        if(this.listOrder === num){
          return
        }else{
          this.listOrder = num
          this.page.pageNum = 1
          this.setPath()
        }
      },
      //  获取我发送的列表
      init(){
        const loading = this.$loading({
          target: this.$refs.listBox,
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
        if (this.$route.query.pageNum) {
          this.page.pageNum = Number(this.$route.query.pageNum)
        } else {
          this.page.pageNum = 1
        }
        if (this.$route.query.key) {
          this.search = this.$route.query.key
        } else {
          this.search = ''
        }
        if (this.$route.query.listOrder) {
          this.listOrder = Number(this.$route.query.listOrder)
        } else {
          this.listOrder = ''
        }
        this.$api.apiContent.myGetTsList({
          search: this.search,
          page: this.page.pageNum,
          pageSize: this.page.pageSize,
          admin_id: this.user.id,
          state: this.listOrder
        }).then(res=>{
           loading.close();
          res.data.map(item=>{
            item.create_time = this.$tools.ZHDate(new Date(item.create_time*1000),1)
          })
          this.tableData = res.data
          this.page.pageTotal = res.total_number
        }).catch(()=>{
           loading.close();
          this.tableData = []
          this.page.pageTotal = 0
        })
      },

      // 列表选中存入数据
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },

      //  点击分页
      handleSizeChange(num) {
        this.page.pageNum = num
      },
      //  选择页数
      handleCurrentChange(num) {
        this.page.pageNum = num
      },

      //  去站内信详情
      toDetail(id,status){
        this.$router.push({
          path:'/home/znxAdmin/znxDetail4/' + id,
          query:{
            status:status
          }
        })
      },
      //  搜索
      keyWord() {
        if(this.page.pageNum === 1){
          this.setPath()
        }else{
          this.page.pageNum = 1
        }
      },
      //  修改路径
      setPath() {
        this.$router.push({
          path: '/home/znxAdmin/znxComplaint',
          query: {
            pageNum: this.page.pageNum,
            key: this.search,
            listOrder:this.listOrder
          }
        })
      },
      //  删除选中的
      deleteList() {
        if (this.multipleSelection.length > 0) {
          let len = this.multipleSelection.length
          this.$confirm('此操作将删除该信息, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let _arr = []
            this.multipleSelection.map(item => {
              _arr.push(item.id)
            })
            this.$api.apiContent.myGetTsDel({
              id: _arr.join(","),
              admin_id: this.user.id
            }).then(res => {
              if (this.page.pageNum > 1 && len === this.list.length) {
                this.page.pageNum = this.page.pageNum - 1
              } else {
                this.init()
              }
              this.$message({
                type: 'success',
                message: res.info
              });
              this.$refs.multipleTable.clearSelection();
            }).catch(res => {
              this.$message.error(res.info);
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        } else {
          this.$message.error("请选中要删除的数据！");
        }
      },
    },
    watch: {
      'page.pageNum'() {
        this.setPath()
      },
      $route() {
        this.init()
      }
    },
    filters:{
      type(val){
        let _str =''
        switch (val) {
          case 1:
            _str = '通知'
            break
          case 2:
            _str = '面试'
            break
          case 3:
            _str = '投诉'
            break
          case 4:
            _str = '留言'
            break
          case 5:
            _str = '提醒发放工资'
            break
        }
        return _str
      }
    },
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .search-box {
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    z-index: 1;
    display: flex;
    justify-content: flex-end;
    .shaixuan{
      position: absolute;
      top: 0;
      right: 340px;
      height: 40px;
      line-height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      a{
        color: #333;
        margin: 0 10px;
        &.active{
          color: #00a2ea;
        }
      }
    }
    .search {
      width: 220px;
    }
  }

  .tab-box {
    position: relative;
    /*top: 64px;*/
    /*left: 10px;*/
    /*right: 10px;*/
    /*bottom: 60px;*/
    min-height: 100%;
    padding-top: 50px;
    padding-bottom: 60px;
    background: #fff;


    .page-box {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 60px;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
</style>